(function () {
  'use strict';

  function initGallery(galleryEl) {
    // Guard against re-init: shopify:block:select fires on the SAME dom
    // node every time a merchant selects a block in the theme editor.
    // Without this, listeners (click/touch/keydown) would stack up.
    if (galleryEl.dataset.igInitialized === 'true') return;
    galleryEl.dataset.igInitialized = 'true';

    var galleryId = galleryEl.id.slice('ig-gallery-'.length);
    var lightbox = document.getElementById('ig-lightbox-' + galleryId);
    if (!lightbox) return;

    var triggers = Array.prototype.slice.call(
      galleryEl.querySelectorAll('.ig-item__trigger')
    );
    if (!triggers.length) return;

    var imgEl = lightbox.querySelector('.ig-lightbox__img');
    var thumbsEl = lightbox.querySelector('.ig-lightbox__thumbs');
    var thumbButtons = Array.prototype.slice.call(
      lightbox.querySelectorAll('.ig-lightbox__thumb')
    );
    var titleEl = lightbox.querySelector('.ig-lightbox__title');
    var creditEl = lightbox.querySelector('.ig-lightbox__credit');
    var descEl = lightbox.querySelector('.ig-lightbox__description');
    var productsSection = lightbox.querySelector('.ig-lightbox__products');
    var productsContainer = lightbox.querySelector('.ig-lightbox__products-grid');
    var closeButtons = lightbox.querySelectorAll('[data-ig-close]');
    var prevBtn = lightbox.querySelector('[data-ig-prev]');
    var nextBtn = lightbox.querySelector('[data-ig-next]');

    var currentIndex = 0;
    var currentImageIndex = 0;
    var lastFocused = null;

    // Returns the {full, alt} for image slot 0 (main), 1 or 2 (subs) of
    // whichever gallery slide is currently open.
    function getImageAt(imageIndex) {
      var trigger = triggers[currentIndex];
      if (imageIndex === 1) {
        return {
          full: trigger.getAttribute('data-ig-sub-1-full') || '',
          alt: trigger.getAttribute('data-ig-sub-1-alt') || ''
        };
      }
      if (imageIndex === 2) {
        return {
          full: trigger.getAttribute('data-ig-sub-2-full') || '',
          alt: trigger.getAttribute('data-ig-sub-2-alt') || ''
        };
      }
      return {
        full: trigger.getAttribute('data-ig-full') || '',
        alt: trigger.getAttribute('data-ig-alt') || ''
      };
    }

    // Displays image slot `imageIndex` large and marks the matching
    // thumbnail as active. Ignores clicks on an empty/hidden slot.
    function selectImage(imageIndex) {
      var image = getImageAt(imageIndex);
      if (!image.full) return;

      imgEl.src = image.full;
      imgEl.alt = image.alt;
      currentImageIndex = imageIndex;

      thumbButtons.forEach(function (btn, i) {
        var isActive = i === currentImageIndex;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    // Fills in the 3 thumbnails for the current slide and hides
    // whichever sub-image slots aren't set. The whole strip hides when
    // neither sub-image is set, since a single thumbnail duplicating
    // the already-visible main image adds nothing.
    function renderThumbnails() {
      if (!thumbsEl || thumbButtons.length < 3) return;

      var hasAnySub = false;
      thumbButtons.forEach(function (btn, i) {
        var image = getImageAt(i);
        var thumbImg = btn.querySelector('img');
        var isMain = i === 0;
        var show = isMain || !!image.full;

        if (show && thumbImg) {
          thumbImg.src = image.full;
          thumbImg.alt = image.alt;
        }
        btn.style.display = show ? '' : 'none';
        if (!isMain && image.full) hasAnySub = true;
      });

      thumbsEl.style.display = hasAnySub ? '' : 'none';
    }

    function renderSlide(index) {
      var trigger = triggers[index];
      var title = trigger.getAttribute('data-ig-title') || '';
      var credit = trigger.getAttribute('data-ig-credit') || '';
      var description = trigger.getAttribute('data-ig-description') || '';

      // The main (first) image is always the default shown when a
      // slide opens or changes, regardless of what was selected before.
      renderThumbnails();
      selectImage(0);

      titleEl.textContent = title;
      titleEl.style.display = title ? '' : 'none';

      if (creditEl) {
        creditEl.textContent = credit;
        creditEl.style.display = credit ? 'inline-block' : 'none';
      }

      descEl.textContent = description;
      descEl.style.display = description ? '' : 'none';

      // Render linked products
      var template = trigger.querySelector('.ig-item__products-template');
      if (productsSection && productsContainer) {
        if (template && template.content && template.content.children.length > 0) {
          productsContainer.innerHTML = '';
          productsContainer.appendChild(template.content.cloneNode(true));
          productsSection.style.display = '';
        } else {
          productsSection.style.display = 'none';
          productsContainer.innerHTML = '';
        }
      }

      prevBtn.style.display = triggers.length > 1 ? '' : 'none';
      nextBtn.style.display = triggers.length > 1 ? '' : 'none';

      // Preload next and previous images
      preloadAdjacent(index);
    }

    function preloadAdjacent(index) {
      var nextIdx = (index + 1) % triggers.length;
      var prevIdx = (index - 1 + triggers.length) % triggers.length;
      
      [nextIdx, prevIdx].forEach(function(i) {
        var src = triggers[i].getAttribute('data-ig-full');
        if (src) {
          var img = new Image();
          img.src = src;
        }
      });
    }

    function openLightbox(index) {
      currentIndex = index;
      lastFocused = document.activeElement;
      renderSlide(currentIndex);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeButtons[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      imgEl.src = '';
      thumbButtons.forEach(function (btn) {
        var thumbImg = btn.querySelector('img');
        if (thumbImg) thumbImg.src = '';
      });
      if (productsContainer) productsContainer.innerHTML = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % triggers.length;
      renderSlide(currentIndex);
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + triggers.length) % triggers.length;
      renderSlide(currentIndex);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') showNext();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'Tab') trapFocus(e);
    }

    function trapFocus(e) {
      var focusable = lightbox.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    // Touch / Swipe Navigation Controls
    if (imgEl) {
      var touchStartX = 0;
      var touchEndX = 0;

      imgEl.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      imgEl.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 50) showNext();
        if (touchEndX - touchStartX > 50) showPrev();
      }, { passive: true });
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openLightbox(index);
      });
    });

    thumbButtons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        selectImage(i);
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });

    nextBtn.addEventListener('click', showNext);
    prevBtn.addEventListener('click', showPrev);
  }

  function initAll() {
    var galleries = document.querySelectorAll('.ig-gallery');
    galleries.forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();